import request from '@/utils/request'

export interface PurchaseListQuery {
  page?: number
  limit?: number
  platform?: string
  userId?: string
  productId?: string
  sourceType?: string
  startDate?: string
  endDate?: string
  search?: string
}

export interface Purchase {
  id: number
  userId: string
  userEmail: string
  userName: string
  featureKey: string
  featureName: string
  sourceType: string
  sourceReference: string
  platform: string
  productId: string
  orderId: string
  startDate: Date
  endDate: Date | null
  isActive: boolean
  createdAt: Date
  metadata: any
}

export interface PurchaseStats {
  summary: {
    total: number
    active: number
    inactive: number
    thisWeek: number
    thisMonth: number
  }
  byPlatform: any[]
  byFeature: any[]
}

export const listPurchases = (params: PurchaseListQuery) =>
  request({
    url: '/admin/purchases',
    method: 'get',
    params
  })

export const getPurchaseById = (id: number) =>
  request({
    url: `/admin/purchases/${id}`,
    method: 'get'
  })

export const getPurchasesByUser = (userId: string, includeInactive: boolean = false) =>
  request({
    url: `/admin/purchases/user/${userId}`,
    method: 'get',
    params: { includeInactive }
  })

export const manualVerification = (id: number, verified: boolean, reason?: string) =>
  request({
    url: `/admin/purchases/${id}/verify`,
    method: 'post',
    data: { verified, reason }
  })

export const processRefund = (id: number, reason: string, notes?: string) =>
  request({
    url: `/admin/purchases/${id}/refund`,
    method: 'post',
    data: { reason, notes }
  })

export const getPurchaseStats = (startDate?: string, endDate?: string) =>
  request({
    url: '/admin/purchases/stats/summary',
    method: 'get',
    params: { startDate, endDate }
  })
